import { render, staticRenderFns } from "./gc-dashboard-empty-state.vue?vue&type=template&id=57130756&scoped=true"
import script from "./gc-dashboard-empty-state.vue?vue&type=script&lang=js"
export * from "./gc-dashboard-empty-state.vue?vue&type=script&lang=js"
import style0 from "./gc-dashboard-empty-state.vue?vue&type=style&index=0&id=57130756&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57130756",
  null
  
)

export default component.exports